!(function () {
	const e = function () {
		'use strict';
		var e, t, o;
		((window.__ectimmers = window.__ectimmers || {}), (window.__ectimmers['ecom-0ghzi5n20rhl'] = window.__ectimmers['ecom-0ghzi5n20rhl'] || {}));
		let i = this.$el;
		if (!i) return;
		let c = !0;
		const n = this.id;
		let r = i.querySelectorAll('.ecom-collection__product-variants'),
			l = this.isLive,
			s = null != (e = this.settings.show_featured_media) && e,
			a = null != (t = this.settings.bage_sale) ? t : '',
			d = null != (o = this.settings.enable_progress_pagination) && o,
			u = this.settings.price_type,
			p = 'bullets';
		const _ = this.settings.slider_center,
			m = this.settings.slider_center__tablet,
			w = this.settings.slider_center__mobile;
		'progress' === this.settings.slider_pagination_style && (p = 'progressbar');
		const h = this.settings.sale_badge_type;
		let y = this.settings.slider_speed,
			f = this.settings.slider_speed__tablet,
			v = this.settings.slider_speed__mobile;
		var g = this.settings;
		const b = function (e, t = {}, o = '') {
			return (window.innerWidth > 1024 && e[0] && (t['' + o] = e[0]), window.innerWidth <= 1024 && window.innerWidth > 768 && e[1] ? (t['' + o] = e[1]) : e[0] && (t['' + o] = e[0]), window.innerWidth < 768 && e[2] ? (t['' + o] = e[2]) : e[1] ? (t['' + o] = e[1]) : e[0] && (t['' + o] = e[0]), t);
		};
		let S = i.querySelectorAll('.ecom-collection__product-item');
		function q(e) {
			e.forEach(function (e) {
				e.setAttribute('data-init-quantity', 'true');
				let t = e.querySelector('.ecom-collection__product-quantity-input'),
					o = e.querySelector('.ecom-collection__quantity-controls-plus'),
					i = e.querySelector('.ecom-collection__quantity-controls-minus');
				(i &&
					i.addEventListener('click', function () {
						(t.stepDown(), t.dispatchEvent(new Event('change')));
					}),
					o &&
						o.addEventListener('click', function () {
							(t.stepUp(), t.dispatchEvent(new Event('change')));
						}),
					t &&
						t.addEventListener('change', function (t) {
							let o = e.querySelector('a.ecom-collection__product-submit');
							if ((t.target.value > parseInt(t.target.max) && (t.target.value = parseInt(t.target.max)), o)) {
								let e = o.getAttribute('href');
								o.setAttribute('href', e.replace(/quantity=(\d*)/gm, 'quantity=' + t.target.value));
							}
						}));
			});
		}
		function L(e = !1, t) {
			const o = i.querySelector('.ecom-paginate__progress-bar--outner'),
				c = i.querySelector('.ecom-paginate__progress-bar--inner'),
				n = i.querySelector('.ecom-paginate__progress-text');
			if (!(d && l && o && c && n)) return;
			let { total: r, initProduct: s } = o && o.dataset,
				a = n && n.dataset.text,
				u = 0,
				p = 1,
				_ = 0,
				m = 0;
			((s = parseInt(s)), e ? ((p = 1), (_ = s * t)) : (window.location.href.match(/page=\d*/gm) && ((u = new URL(window.location.href).searchParams.get('page')), (p = 1 === u ? 1 : s * (u - 1) + 1)), (_ = p + s - 1)), _ > r && (_ = r), (m = Math.round((_ / r) * 100)), (c.style.width = m + '%'), (a = a.replace('{_start}', p)), (a = a.replace('{_end}', _)), (a = a.replace('{_total}', r)), (n.innerText = a));
		}
		function E(e, t) {
			var o = t.variantIdField.closest('.ecom-collection__product-item');
			let c = o.querySelector('.ecom-collection__product-submit'),
				n = o.querySelector('.ecom-collection__product-quantity-input'),
				r = o.querySelector('.ecom-collection__product-price'),
				d = o.querySelector('.ecom-collection__product-price--regular'),
				p = o.querySelector('.ecom-unit-price');
			d && d.classList.add('ecom-collection__product--compare-at-price');
			let _ = o.querySelector('.ecom-collection__product-price--bage-sale'),
				m = o.querySelector('.ecom-collection__product-badge--sale'),
				w = o.querySelector('.ecom-collection__product-badge--sold-out'),
				y = o.querySelector('.ecom-collection__product-item-sku-element'),
				f = '';
			if (null === e || (o.hasAttribute('ec-variant-init') && 'first_price' === u)) {
				let t = o.querySelector('select[name="variant_id"]'),
					i = o.querySelector('.product-json'),
					c = null;
				try {
					c = JSON.parse(i.innerHTML);
				} catch (e) {
					return 1;
				}
				if (o.hasAttribute('ec-variant-init') && 'first_price' === u) (o.removeAttribute('ec-variant-init'), null == (e = c.variants.find((e) => e.available)) && (e = c.variants[0]));
				else {
					let i = o.querySelector('select#' + t.id + '-option-0');
					if (!i) return;
					const n = i.value;
					n &&
						c.variants.forEach(function (t) {
							t.options.includes(n) && (e = t);
						});
				}
			}
			if (e) {
				if ((r && (r.innerHTML = window.EComposer.formatMoney(e.price)), d && (d.innerHTML = window.EComposer.formatMoney(e.compare_at_price)), p)) {
					e.unit_price ? (p.style.display = 'block') : (p.style.display = 'none');
					const t = p.querySelector('.ecom-ground-price_unit-price');
					t && (t.innerHTML = window.EComposer.formatMoney(e.unit_price));
				}
				if (e.compare_at_price > e.price) {
					d && (d.style.display = 'inherit');
					let t = '';
					((t = i.querySelector('.ecom-collection__product-main').dataset.sale), 'false' == i.querySelector('.ecom-collection__product-main').dataset.translate && (t = a), m && w && ((m.style.display = 'block'), (w.style.display = 'none')));
					const o = /\{{.*\}}/g,
						c = /\(\(.*\)\)/g;
					'amount' === h ? ((f = e.compare_at_price - e.price), _ && ((_.style.display = 'inherit'), o.test(t) ? (_.innerHTML = t.replace(o, window.EComposer.formatMoney(f))) : c.test(t) && (_.innerHTML = t.replace(c, window.EComposer.formatMoney(f))))) : ((f = (100 * (e.compare_at_price - e.price)) / e.compare_at_price), _ && ((_.style.display = 'inherit'), o.test(t) ? (_.innerHTML = t.replace(o, Math.round(f))) : c.test(t) && (_.innerHTML = t.replace(c, Math.round(f)))));
				} else (d && (d.style.display = 'none'), m && w && ((m.style.display = 'none'), (w.style.display = 'none')), _ && ((_.style.display = 'none'), (_.innerHTML = '')));
				if ((y && (e.sku ? ((y.querySelector('.ecom-collection__product-item-sku').innerHTML = e.sku), (y.style.display = 'flex')) : (y.style.display = 'none')), e.featured_image)) {
					let t = o.querySelector('.ecom-collection__product-media img');
					if (!s) {
						let o = t.closest('div');
						(o.classList.add('ecom-product-image-loading'),
							t.setAttribute('src', e.featured_image.src),
							t.removeAttribute('srcset'),
							t.addEventListener('load', function () {
								o.classList.remove('ecom-product-image-loading');
							}));
					}
				}
				if ((e.options.length, o.querySelector('.ecom-collection__product-submit')))
					if (e.available) {
						const t = c.closest('.ecom-collection__product--wrapper-items');
						if ((t.dataset.iconAdd && c.querySelector('.ecom-collection__product-add-cart-icon') && (c.querySelector('.ecom-collection__product-add-cart-icon').innerHTML = t.dataset.iconAdd), !e.inventory_management || (e.inventory_management && e.inventory_quantity > 0))) {
							if ((c.removeAttribute('disabled'), n)) {
								let t = n.closest('.ecom-collection__product-quantity--wrapper');
								(t && (t.style.display = 'flex'), (n.style.display = 'flex'), e.inventory_management ? (n.max = e.inventory_quantity) : (n.max = 9999));
							}
							(c.classList.add('ecom-collection__product-form__actions--add'), c.classList.remove('ecom-collection__product-form__actions--soldout'), c.classList.remove('ecom-collection__product-form__actions--unavailable'), (c.querySelector('.ecom-add-to-cart-text').innerHTML = c.getAttribute('data-text-add-cart')));
						} else if ('continue' == e.inventory_policy && e.inventory_quantity <= 0) {
							if ((c.removeAttribute('disabled'), n)) {
								let e = n.closest('.ecom-collection__product-quantity--wrapper');
								(e && (e.style.display = 'flex'), (n.max = 9999), (n.style.display = 'flex'));
							}
							(c.classList.add('ecom-collection__product-form__actions--add'), c.classList.remove('ecom-collection__product-form__actions--soldout'), c.classList.remove('ecom-collection__product-form__actions--unavailable'), (c.querySelector('.ecom-add-to-cart-text').innerHTML = c.getAttribute('data-text-pre-order')));
						}
						((c.dataset.childName = 'add_to_cart_button'), (c.dataset.childTitle = 'Add to cart button'));
					} else {
						if ((m && w && ((m.style.display = 'none'), (w.style.display = 'block')), l && c.setAttribute('disabled', 'disabled'), n)) {
							let e = n.closest('.ecom-collection__product-quantity--wrapper');
							(e && (e.style.display = 'none'), (n.style.display = 'none'));
						}
						const e = c.closest('.ecom-collection__product--wrapper-items');
						(e.dataset.iconSoldout && c.querySelector('.ecom-collection__product-add-cart-icon') && (c.querySelector('.ecom-collection__product-add-cart-icon').innerHTML = e.dataset.iconSoldout), c.classList.add('ecom-collection__product-form__actions--soldout'), c.classList.remove('ecom-collection__product-form__actions--add'), c.classList.remove('ecom-collection__product-form__actions--unavailable'), (c.querySelector('.ecom-add-to-cart-text').innerHTML = c.getAttribute('data-text-sold-out')), (c.dataset.childName = 'sold_out_button'), (c.dataset.childTitle = 'Sold out button'));
					}
			} else ((r.html = window.EComposer.formatMoney(0)), d && ((d.innerHTML = window.EComposer.formatMoney(0)), (d.style.display = 'none')), c && (c.setAttribute('disabled', 'disabled'), c.classList.add('ecom-collection__product-form__actions--unavailable'), c.classList.remove('ecom-collection__product-form__actions--add'), c.classList.remove('ecom-collection__product-form__actions--soldout'), (c.querySelector('.ecom-add-to-cart-text').innerHTML = c.getAttribute('data-text-unavailable'))));
		}
		function x(e) {
			if (e.classList.contains('ecom-swatch-init')) return;
			e.classList.add('ecom-swatch-init');
			let t = e.querySelector('.ecom-collection__product-form');
			if (!t) return;
			let o = t.querySelector('select[name="variant_id"]'),
				i = e.querySelector('.product-json'),
				c = null;
			try {
				c = JSON.parse(i.innerHTML);
			} catch (e) {
				return 1;
			}
			(window.EComposer && window.EComposer.OptionSelectors && !o.dataset.ecomOptionInit && ((o.dataset.ecomOptionInit = 'true'), new window.EComposer.OptionSelectors(o.id, { product: c, onVariantSelected: E, enableHistoryState: !1 })),
				e.querySelectorAll('.ecom-collection__product-swatch-item').forEach(function (t) {
					t.addEventListener('click', function () {
						s = !1;
						var t = this.closest('li');
						if (t.classList.contains('ecom-product-swatch-item--active')) return !1;
						(t.parentNode.querySelectorAll('.ecom-product-swatch-item--active').forEach(function (e) {
							e.classList.remove('ecom-product-swatch-item--active');
						}),
							t.classList.add('ecom-product-swatch-item--active'));
						var i = t.getAttribute('data-option-index'),
							c = t.getAttribute('data-value');
						let n = e.querySelector('select#' + o.id + '-option-' + i);
						((n.value = c), n.dispatchEvent(new Event('change')));
					});
				}),
				e.querySelectorAll('select.ecom-collection__product-swatch-select').forEach(function (t) {
					t.addEventListener('change', function () {
						var t = this.getAttribute('data-option-index'),
							i = this.value;
						e.querySelectorAll('select#' + o.id + '-option-' + t).forEach(function (e) {
							((e.value = i), e.dispatchEvent(new Event('change')));
						});
					});
				}));
		}
		if ((S.length && q(S), L(!1, 1), 'slider' === this.settings.layout)) {
			let e = function (t) {
					var o = t.querySelector('.ecom-swiper-container');
					if (!o) return;
					if (!window.EComposer || 'function' != typeof window.EComposer.buildSwiperConfig) {
						let o = 0;
						const i = (window.__ectimmers['ecom-0ghzi5n20rhl']['5e99pcdb7'] = setInterval(function () {
							(o++, window.EComposer && 'function' == typeof window.EComposer.buildSwiperConfig ? (clearInterval(i), e(t)) : o >= 20 && clearInterval(i));
						}, 200));
						return;
					}
					var i = (function (e) {
						return window.EComposer && 'function' == typeof window.EComposer.buildSwiperConfig ? window.EComposer.buildSwiperConfig(e) : null;
					})(g);
					if (!i) return;
					((i.pagination = { el: t.querySelector('.ecom-swiper-pagination'), type: p, clickable: !0 }),
						(i.navigation = { nextEl: t.querySelector('.ecom-swiper-button-next'), prevEl: t.querySelector('.ecom-swiper-button-prev') }),
						(i.allowTouchMove = l),
						(i.autoHeight = !1),
						(i.on = {
							init: function () {
								this.el.classList.add('ecom-swiper-initialized');
							},
						}));
					let c = [y, f, v];
					if (l) {
						((i = b(c, i, 'speed')), (i = b([_, m, w], i, 'centeredSlides')));
						const e = new window.EComSwiper(o, i);
						i.autoplay.enabled &&
							(e.on('touchStart', function (e, t) {
								((e.params.speed = 300), e.autoplay.stop());
							}),
							e.on('touchEnd', function (e, t) {
								(window.innerWidth > 1024 && y && (e.params.speed = y), window.innerWidth <= 1024 && window.innerWidth > 768 && f ? (e.params.speed = f) : y && (e.params.speed = y), window.innerWidth < 768 && v ? (e.params.speed = v) : f ? (e.params.speed = f) : y && (e.params.speed = y), e.autoplay.start());
							}));
					} else
						setTimeout(function () {
							((i = b(c, i, 'speed')), (i = b([_, m, w], i, 'centeredSlides')), new window.EComSwiper(o, i));
						}, 200);
				},
				t = this.$el,
				o = t.querySelector('.ecom-collection__product-container');
			(e(t),
				o.addEventListener('ecom-products-init-slider', function (t) {
					e(t.detail.wrapper);
				}));
		}
		r.forEach(x);
		const k = function (e) {
			(e.querySelectorAll('.ecom-collection__product-form__actions--quickshop').forEach(function (e) {
				e.addEventListener('click', function (e) {
					this.style.display = 'none';
					let t = this.closest('.ecom-collection__product-item');
					(t.querySelectorAll('.ecom-collection__product-variants').forEach(function (e) {
						e.classList.add('ecom-active');
					}),
						t.querySelectorAll('.ecom-collection__product-quick-shop-wrapper').forEach(function (e) {
							e.style.display = 'inherit';
						}));
				});
			}),
				e.querySelectorAll('.ecom-collection__product-close').forEach(function (e) {
					e.addEventListener('click', function (e) {
						let t = this.closest('.ecom-collection__product-item');
						(t.querySelectorAll('.ecom-collection__product-variants').forEach(function (e) {
							e.classList.remove('ecom-active');
						}),
							t.querySelectorAll('.ecom-collection__product-quick-shop-wrapper').forEach(function (e) {
								e.style.display = 'none';
							}),
							t.querySelectorAll('.ecom-collection__product-form__actions--quickshop').forEach(function (e) {
								e.style.display = 'inherit';
							}));
					});
				}));
		};
		k(i);
		const C = i.querySelector('.ecom-collection__product-main');
		let A = C.dataset,
			M = C.dataset.countdownShows;
		const T = /\[([^\]]+)\]/gm;
		var H = '';
		if (M.indexOf('week') >= 0 && A.week) {
			let e = '',
				t = A.week.replace(T, (...t) => ((e = t[1]), ''));
			H += `\n                            <div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--week">\n                                <span class="ecom-collection__product-time--number">\n                                    ${e}\n                                </span>\n                                <span class="ecom-collection__product-time--label">\n                                    ${t}\n                                </span>\n                            </div>`;
		}
		if (M.indexOf('day') >= 0 && A.day) {
			let e = '',
				t = A.day.replace(T, (...t) => ((e = t[1]), ''));
			H += `<div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--day">\n                                    <span class="ecom-collection__product-time--number">\n                                        ${e}\n                                    </span>\n                                    <span class="ecom-collection__product-time--label">\n                                        ${t}\n                                    </span>\n                                </div> `;
		}
		if (M.indexOf('hour') >= 0 && A.hour) {
			let e = '',
				t = A.hour.replace(T, (...t) => ((e = t[1]), ''));
			H += `\n                            <div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--hour">\n                                <span class="ecom-collection__product-time--number">\n                                    ${e}\n                                </span>\n                                <span class="ecom-collection__product-time--label">\n                                    ${t}\n                                </span>\n                            </div>\n                        `;
		}
		if (M.indexOf('minute') >= 0 && A.minute) {
			let e = '',
				t = A.minute.replace(T, (...t) => ((e = t[1]), ''));
			H += `<div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--minute">\n                                    <span class="ecom-collection__product-time--number">\n                                        ${e}\n                                    </span>\n                                    <span class="ecom-collection__product-time--label">\n                                        ${t}\n                                    </span>\n                                </div>\n                            `;
		}
		if (M.indexOf('second') >= 0 && A.second) {
			let e = '',
				t = A.second.replace(T, (...t) => ((e = t[1]), ''));
			H += `<div class="ecom-collection__product-time--item ecom-d-flex ecom-collection__product-time--second">\n                                    <span class="ecom-collection__product-time--number">\n                                        ${e}\n                                    </span>\n                                    <span class="ecom-collection__product-time--label">\n                                        ${t}\n                                    </span>\n                                </div>`;
		}
		function $(e) {
			let t = this.closest('.ecom-collection__product-countdown-wrapper'),
				o = t.querySelector('.ecom-collection__product-countdown-progress-bar'),
				i = t.querySelector('.ecom-collection__product-countdown-progress-bar--timer'),
				c = this.getAttribute('data-ecom-countdown-from') || 0;
			if (((this.innerHTML = e.strftime(H)), o && c)) {
				let t = new Date().getTime(),
					n = new Date(c).getTime(),
					r = e.finalDate.getTime();
				if (n < t && r > n) {
					o.style.removeProperty('display');
					let e = r - n,
						c = r - t,
						l = Math.round((100 * c) / e) + '%';
					i.style.width = l;
				} else o.style.display = 'none';
			}
		}
		function P(e) {
			if (e.dataset.ecomCountdown) {
				if (e.dataset.ecomCountdownFrom && new Date().getTime() > new Date(e.dataset.ecomCountdown).getTime() && l) return ((e.closest('.ecom-collection__product-countdown-wrapper').style.display = 'none'), !1);
				(window.EComCountdown && window.EComCountdown(e, new Date(e.dataset.ecomCountdown), $),
					e.addEventListener('stoped.ecom.countdown', () => {
						e.closest('.ecom-collection__product-countdown-wrapper').style.display = 'none';
					}));
			}
		}
		if (
			(i.querySelectorAll('.ecom-collection__product-countdown-time').forEach(function (e) {
				P(e);
			}),
			l)
		) {
			const e = i.querySelector('.ecom-collection__product-main');
			let t = 1;
			const o = function (e) {
					e.preventDefault();
					const o = this.dataset.get,
						c = this.closest('.ecom-sections[data-section-id]'),
						n = i.closest('.ecom-row.ecom-section');
					if (!o || !c || !c.dataset.sectionId) return;
					const l = `${o}&section_id=${c.dataset.sectionId}`;
					(t++, L(!0, t), this.classList.add('ecom-loading'), r(l, c, this, 'loadmore', n));
				},
				n = function (e) {
					var t, o;
					((t = e),
						(o = {}),
						new IntersectionObserver((e, n) => {
							e.forEach((e) => {
								e.isIntersecting &&
									(o.cb
										? o.cb(t)
										: (function (e) {
												const t = e.dataset.get,
													o = e.closest('.ecom-sections[data-section-id]'),
													n = e.closest('.ecom-row.ecom-section');
												if (!t || !o || !o.dataset.sectionId) return;
												const l = o.dataset.sectionId,
													s = `${t}&section_id=${l}`;
												c && (i.classList.add('ecom-doing-scroll'), r(s, o, e, 'infinite', n));
											})(e.target),
									n.unobserve(e.target));
							});
						}, o).observe(t));
				},
				r = function (t, o, r, l, s) {
					((c = !1),
						(async function (e) {
							return (await fetch(e, { method: 'GET', cache: 'no-cache', headers: { 'Content-Type': 'text/html' } })).text();
						})(t)
							.then(function (t) {
								const o = document.createElement('div');
								o.innerHTML = t;
								const i = o.querySelector('.ecom-collection__product-main.ecom-collection_product_template_collection .ecom-collection__product--wrapper-items');
								if (!i) return;
								const c = s.querySelector('.ecom-collection__product--wrapper-items'),
									a = s.querySelector('.ecom-products-pagination-loadmore');
								for (; i.firstChild; ) c.appendChild(i.firstChild);
								if ((i.parentNode.removeChild(i), 'loadmore' === l)) {
									const e = o.querySelector('.ecom-products-pagination-loadmore');
									e ? (a.innerHTML = e.innerHTML) : a.remove();
								} else {
									r.remove();
									const e = o.querySelector('.ecom-products-pagination-infinite');
									e && (c.after(e), n(e));
								}
								e.dispatchEvent(new CustomEvent('ecom-products-init', { detail: { wrapper: e } }));
							})
							.finally(function () {
								(window.EComposer && window.EComposer.initQuickview && 'function' == typeof window.EComposer.initQuickview && window.EComposer.initQuickview(), (c = !0), i.classList.remove('ecom-doing-scroll'), r.classList.remove('ecom-loading'));
							}));
				};
			if (e && e.dataset.pagination) {
				const t = e.dataset.pagination;
				if ('loadmore' === t) i.querySelector('.ecom-products-pagination-loadmore-btn') && i.querySelector('.ecom-products-pagination-loadmore-btn').addEventListener('click', o);
				else if ('infinit' === t) {
					const e = i.querySelector('.ecom-products-pagination-infinite');
					e && n(e);
				}
			}
			e.addEventListener('ecom-products-init', function (t) {
				const c = t.detail.wrapper;
				if (!c) return;
				if (e && e.dataset.pagination) {
					const t = e.dataset.pagination;
					if ('loadmore' === t) i.querySelector('.ecom-products-pagination-loadmore-btn') && i.querySelector('.ecom-products-pagination-loadmore-btn').addEventListener('click', o);
					else if ('infinit' === t) {
						const e = i.querySelector('.ecom-products-pagination-infinite');
						e && n(e);
					}
				}
				(c.querySelectorAll('.ecom-collection__product-variants:not(.ecom-swatch-init)').length && c.querySelectorAll('.ecom-collection__product-variants:not(.ecom-swatch-init)').forEach(x),
					c.querySelectorAll('.ecom-collection__product-countdown-time').length &&
						c.querySelectorAll('.ecom-collection__product-countdown-time').forEach(function (e) {
							P(e);
						}),
					k(c));
				let r = c.querySelectorAll(".ecom-collection__product-item:not([data-init-quantity='true'])");
				(r.length && q(r), c.querySelector('.ecom-products-pagination-loadmore-btn') && c.querySelector('.ecom-products-pagination-loadmore-btn').addEventListener('click', o), window.EComposer && 'function' == typeof window.EComposer.init && window.EComposer.init(), I(c));
				(B(c.querySelector('.ecom-collection__product--wishlist-wrapper')), L(!1, 1));
			});
		}
		function I(e) {
			if (e && e.dataset.reviewPlatform)
				switch (e.dataset.reviewPlatform) {
					case 'product-reviews':
						if (window.SPR)
							try {
								((window.SPR.$ = window.jQuery), window.SPR.initDomEls(), window.SPR.loadBadges());
							} catch (e) {
								console.info(e.message);
							}
						break;
					case 'judgeme':
						if (window.jdgm) {
							try {
								window.jdgm.batchRenderBadges();
							} catch (e) {
								console.info(e.message);
							}
							i.querySelectorAll('[data-average-rating="0.00"]').forEach(function (e) {
								e.style.display = 'block !important';
							});
						}
						break;
					case 'product-reviews-addon':
						window.StampedFn && window.StampedFn.loadBadges();
						break;
					case 'lai-reviews':
						void 0 !== window.SMARTIFYAPPS && window.SMARTIFYAPPS.rv.installed && window.SMARTIFYAPPS.rv.scmReviewsRate.actionCreateReviews();
						break;
					case 'air-reviews':
						'function' == typeof window.avadaAirReviewRerender && window.avadaAirReviewRerender();
				}
		}
		function B(e) {
			if (e)
				switch (e.dataset.wishlistApp) {
					case 'swym-relay':
						window._swat && window._swat.initializeActionButtons('.ecom-collection__product-wishlist-button');
						break;
					case 'wishlist-hero':
						i.querySelectorAll('.wishlist-hero-custom-button').forEach(function (e) {
							var t = new CustomEvent('wishlist-hero-add-to-custom-element', { detail: e });
							document.dispatchEvent(t);
						});
				}
		}
		if (!l) {
			I(i.querySelector('.ecom-collection__product-main'));
			B(i.querySelector('.ecom-collection__product--wishlist-wrapper'));
		}
		this.settings.enable_preload &&
			i.querySelectorAll('.ecom-collection__product-item').forEach(function (e) {
				e.addEventListener(
					'mouseenter',
					function () {
						let e = document.createElement('link');
						((e.rel = 'prefetch'), document.head.appendChild(e));
						var t = this.querySelector('a.ecom-collection__product-item-information-title');
						!t || (e.href = t.getAttribute('href'));
					},
					{ once: !0 },
				);
			});
		this.settings.show_compare &&
			!l &&
			i.querySelectorAll('.ecom-product__compare-link').forEach(function (e) {
				e.addEventListener('click', function () {
					this.classList.contains('ecom-product__compare-link-added') ? this.classList.remove('ecom-product__compare-link-added', 'ecom-button-active') : this.classList.add('ecom-product__compare-link-added', 'ecom-button-active');
				});
			});
		this.settings.show_wishlist &&
			!l &&
			i.querySelectorAll('.ecom-product__wishlist-link').forEach(function (e) {
				e.addEventListener('click', function () {
					this.classList.contains('ecom-product__wishlist-link-added') ? this.classList.remove('ecom-product__wishlist-link-added', 'ecom-button-active') : this.classList.add('ecom-product__wishlist-link-added', 'ecom-button-active');
				});
			});
		if ('recommendations' === this.settings.show_product_by && l) {
			let e = i.closest('.ecom-builder');
			if (e) {
				let t = e.querySelector('.ecom-sections').dataset.sectionId,
					o = e.querySelector('input[name="product-id"]') ? e.querySelector('input[name="product-id"]').value : '',
					c = 8,
					r = i.querySelector('.ecom-collection__product-container'),
					l = i.querySelector('.ecom-collection__product-main');
				(l.classList.contains('ecom-collection_product_template_product') && 'recommendations' === this.settings.show_product_by && (c = this.settings.limit_recommended_products),
					fetch(`${window.Shopify.routes.root}recommendations/products?product_id=${o}&limit=${c}&section_id=${t}`)
						.then((e) => e.text())
						.then((e) => {
							const o = document.createElement('div');
							o.innerHTML = e;
							const i = o.querySelector(`[data-section-id="${t}"]`),
								c = i.querySelector('.ecom-block.' + n);
							if (!c) return void console.warn(`Block with ID ${n} not found in recommendations.`);
							const s = c.querySelector('.ecom-collection__product-main');
							i.innerHTML.trim().length && l && ((l.innerHTML = s.innerHTML), l.querySelector('.ecom-collection__product--wrapper-items') && l.dispatchEvent(new CustomEvent('ecom-products-init', { detail: { wrapper: l } })), r.dispatchEvent(new CustomEvent('ecom-products-init-slider', { detail: { wrapper: r } })));
						})
						.catch((e) => {
							console.error(e);
						}));
			}
		}
	};
	document.querySelectorAll('.ecom-0ghzi5n20rhl').forEach(function (t) {
		e.call({ $el: t, id: 'ecom-0ghzi5n20rhl', settings: { show_featured_media: !1, bage_sale: 'Save {{sale}}', price_type: 'first_price', sale_badge_type: 'percent', slider_speed: 200, layout: 'grid', enable_preload: !1, show_compare: !1, show_wishlist: !1, show_product_by: 'condition', limit_recommended_products: 8, image_ratio: 'adapt', disable_lazyload: !1, placeholder_image_shopify: 'product-1', link_with_collection: !0, show_secondary_image: !0, hover_show_image_mobile: !0, show_sale_badge: !0, show_badges: !0, show_bss_b2b_wholesale: !1, title_tag: 'h3', pagination_type: 'default', number_type: 'dropdown', enable_countdown: !0, enable_progress_bar: !0, countdown_title: 'Hurry up! The sale will end on', sale_text: 'Sale', sold_text: 'Sold out', order_login_to_see_price: 8, show_login_to_see_price_text: !1, login_to_see_price_text: 'Login to see price', show_text_first: 'column', text_progress_pagination: 'Viewing {_start} - {_end} of {_total}', price_from_text: 'From', product_unavailable: 'Unavailable', product_outstock: 'Outstock', show_product_available: !1, show_variant_label: 'block', show_option_name: 'none', slider_items: 4, show_vendor: !1, show_sku: !1, show_description: !1, show_type: !1, show_price: 'block', hide_price_if_not_logged_in: !1, show_product_rating: !1, show_product_quickview: !1, show_product_wishlist: !1, vendor_title: 'Vendor', type_title: 'Type', limit: 8, badge_tags: 'Hot,Best Selling,Trending Item', trans_no_item: 'There are no product yet!', show_picker: 'show', show_actions: !0, type: 'image', option: 'Color', option_layout: 'radio', quickshop_layout: 'full', shows_countdown: ['day', 'hour', 'minute', 'second'], text_week: '[%-W] week%!W', text_day: '[%-d] day%!D', text_hour: '[%-H] hr%!H', text_minute: '[%-M] min%!M', text_second: '[%-S] sec%!S', text_prev_page: 'Previous', text_next_page: 'Next', 'grid-column-gap': '10px', action: 'popup', added_cart_text: 'Added to cart', added_cart_message: 'Added to cart', slidesPerView__tablet: 3, spaceBetween__tablet: 30, slidesPerView__mobile: 1, spaceBetween__mobile: 15, enable_pagination: !0, row_items: 4, imagePos: 'ecom-flex-column', 'grid-template-columns': 3, show_countdown_on_sale: !1, countdown_from: '2021/11/01 12:00', navigation: !0, slidesPerView: 4, slidesPerGroup: 1, spaceBetween: 30, order_title: 1, order_description: 9, order_vendor: 3, order_sku: 4, order_type: 5, order_price: 7, order_button: 10, order_variant: 9, slider_items__tablet: 3, slider_items__mobile: 1, slider_navigation_layout: 'navigation', slider_prev_icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" fill="currentColor"><path d="M192 448c-8.188 0-16.38-3.125-22.62-9.375l-160-160c-12.5-12.5-12.5-32.75 0-45.25l160-160c12.5-12.5 32.75-12.5 45.25 0s12.5 32.75 0 45.25L77.25 256l137.4 137.4c12.5 12.5 12.5 32.75 0 45.25C208.4 444.9 200.2 448 192 448z"></path></svg>', slider_next_icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 512" fill="currentColor"><path d="M64 448c-8.188 0-16.38-3.125-22.62-9.375c-12.5-12.5-12.5-32.75 0-45.25L178.8 256L41.38 118.6c-12.5-12.5-12.5-32.75 0-45.25s32.75-12.5 45.25 0l160 160c12.5 12.5 12.5 32.75 0 45.25l-160 160C80.38 444.9 72.19 448 64 448z"></path></svg>', slider_spacing: 20, styleCountdown: 'column', sku_title: 'SKU: ', quickview_text: 'Quick view', quickview_icon: '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-zoom-in"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line><line x1="11" y1="8" x2="11" y2="14"></line><line x1="8" y1="11" x2="14" y2="11"></line></svg>', order_reivew: 2, quick_shop_text: 'Quick Shop', order_countdown: 1, placeholder_image: !1, placeholder_image_custom: { value: '/images/placeholder.png' }, slider_spacing__mobile: 15, slider_spacing__tablet: 15, slider_loop: !0, style: 'vertical', add_to_cart: 'Add to cart ', pre_order: 'Pre order', view_more_text: 'View more', sold_out_text: 'Sold out', quantity_inline: !1, compare_tab: 'compare_tab_normal', tab_tooltip_compare: 'tab_tooltip_compare_normal', navigation_position: 'center', navigation_position__tablet: 'center', navigation_position__mobile: 'center', wishlist_icon: { value: '<svg xmlns="http://www.w3.org/2000/svg" width="52" height="52" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-heart"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"></path></svg>' }, wishlist_icon_added: { value: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M22.5,5c-2.892,0-5.327,1.804-6.5,2.854C14.827,6.804,12.392,5,9.5,5C5.364,5,2,8.364,2,12.5c0,2.59,2.365,4.947,2.46,5.041 L16,29.081l11.534-11.534C27.635,17.447,30,15.09,30,12.5C30,8.364,26.636,5,22.5,5z"></path></svg>' }, compare_icon: { value: '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="16 3 21 3 21 8"></polyline><line x1="4" y1="20" x2="21" y2="3"></line><polyline points="21 16 21 21 16 21"></polyline><line x1="15" y1="15" x2="21" y2="21"></line><line x1="4" y1="4" x2="9" y2="9"></line></svg>' }, compare_icon_added: { value: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="currentColor"><path d="M 16 3 C 8.800781 3 3 8.800781 3 16 C 3 23.199219 8.800781 29 16 29 C 23.199219 29 29 23.199219 29 16 C 29 14.601563 28.8125 13.207031 28.3125 11.90625 L 26.6875 13.5 C 26.886719 14.300781 27 15.101563 27 16 C 27 22.101563 22.101563 27 16 27 C 9.898438 27 5 22.101563 5 16 C 5 9.898438 9.898438 5 16 5 C 19 5 21.695313 6.195313 23.59375 8.09375 L 25 6.6875 C 22.699219 4.386719 19.5 3 16 3 Z M 27.28125 7.28125 L 16 18.5625 L 11.71875 14.28125 L 10.28125 15.71875 L 15.28125 20.71875 L 16 21.40625 L 16.71875 20.71875 L 28.71875 8.71875 Z"></path></svg>' }, content_tooltip_wishlist: 'Add to Wishlist', content_tooltip_wishlist_added: 'Browse Wishlist', content_tooltip_compare_added: 'Compare products', content_tooltip_compare: 'Compare' }, isLive: !0 });
	});
})();
